export default {
  Pedidos: axios.create({
    baseURL: process.env.VUE_APP_ENDPOINT_API + "pedidos"
  })
}


//////////////////
// WEBPACK FOOTER
// ../core/resources/routes/Pedidos.js
// module id = x3ut
// module chunks = 13